<template>
  <div class="login-body">
    <div class="box">
      <form @submit.prevent="submitForm">
        <div style="display: flex; justify-content: center; caret-color: transparent; cursor: pointer;">
          <img @contextmenu.prevent src="/TheMedia/Login%20Company%20Logo-2b4134c8-f075-49ab-ada2-7624d4979b0f.png" @click.prevent="returnHome()">
        </div>

        <div class="input-box">
          <input type="text" placeholder="Username" v-model="username" required>
          <i class="fa-solid fa-user"></i>
        </div>

        <div class="input-box">
          <input :type="isPasswordVisible ? 'text' : 'password'"  placeholder="Password" v-model="password" required>
          <i class="fa-solid fa-lock" v-if="!password"></i>
          <div v-else>
            <i style="right: 18px !important;" class="fa-solid" :class="isPasswordVisible ? 'fa-eye-slash' : 'fa-eye'" @click="togglePasswordVisibility"></i>
            <!-- <i class="fa-solid fa-eye-slash"></i> -->
          </div>
        </div>

        <div style="display: flex; margin-bottom: 50px;">
          <img style="transform: scale(1); width: 100px; height: 50px;" :src="captchaUrl" alt="CAPTCHA Image" />
          <input class="input-box" style="margin: 0px !important; padding-left: 7px; outline: none; height: 50px;" type="text" placeholder="Code" v-model="txtCaptcha" h required>
          <button type="button" @click.prevent="refreshCaptcha" style="color: #787878; margin-left: 10px;"><i style="margin: 0 10px;" class="fa-solid fa-arrows-rotate"></i></button>
        </div>

        <button type="submit" style="margin-top: -10px;" class="btn-submit" :class="{ loading: isLoading }">
          <span class="btn-text" style="color: #DBA30D; font-weight: 700;">Login FTC</span>
        </button>

        <!-- <div class="g-recaptcha" style="margin-top: 10px; margin-left: 22px;" data-sitekey="6LdIQlwqAAAAAPyKKmSZUIBPiAYoLs18FbV_Fdk4"></div> -->
      </form>
    </div>
  </div>
</template>
<!-- <script src="https://www.google.com/recaptcha/api.js" async defer></script> -->
<script>
import axios from 'axios'

export default {
  data () {
    return {
      isLoading: false,
      accounts: [],
      username: '',
      password: '',
      txtCaptcha: '',
      isPasswordVisible: false,
      captchaUrl: this.buildCaptchaUrl()
    }
  },

  mounted () {
    this.$store.state.isLoggedIn = false
    // Dynamically load the Google reCAPTCHA script when the component is mounted
    const scriptId = 'recaptcha-script'
    // console.log('Google reCAPTCHA .')
    const script = document.createElement('script')
    script.src = 'https://www.google.com/recaptcha/api.js'
    script.async = true
    script.defer = true
    script.id = scriptId // To avoid duplicate script load
    document.head.appendChild(script)

    // Optionally: Listen for the script load to handle further logic
    script.onload = () => {
      console.log('Google reCAPTCHA script loaded.')

      // Initialize reCAPTCHA or execute any callback if needed
    }
    // if (!document.getElementById(scriptId)) {

    // }
  },
  methods: {
    togglePasswordVisibility () {
      this.isPasswordVisible = !this.isPasswordVisible // toggle visibility
    },
    submitForm () {
      this.login()
    },
    returnHome () {
      this.$router.push('/')
    },
    buildCaptchaUrl () {
      return `api/Captcha/Generate?${Date.now()}`
    },
    refreshCaptcha () {
      this.captchaUrl = this.buildCaptchaUrl()
    },
    async login () {
      this.isLoading = true

      // const rs = window.grecaptcha.getResponse()
      // if (!rs) {
      //   this.password = ''
      //   this.isLoading = false
      //   this.$showError('Recaptcha Failure, Try Again')
      //   return
      // }
      // window.grecaptcha.reset()
      try {
        const response = await axios.post(this.$store.state.API_Url + 'Users', {
          username: this.username,
          password_hash: this.password,
          txtCaptcha: this.txtCaptcha
        })
        // console.log('Test recaptcha')
        // window.grecaptcha.reset()
        // if (!response.data.authenticated) {
        //   this.$showError('Invalid Login Credentials')
        //   this.password = ''
        //   this.isLoading = false

        //   return
        // }

        this.$store.state.isLoggedIn = response.data.accessAdmin
        this.$store.state.userId = response.data.userId
        this.$store.state.username = this.username
        this.$store.state.email = response.data.email
        this.$store.state.userRoles = response.data.role_list
        this.$store.state.userPermissions = response.data.permission_descriptions
        this.$store.state.userPermissionNames = response.data.permission_list
        this.$store.state.token = response.data.jwtToken
        this.$store.dispatch('initializeAxios', response.data.jwtToken)
        // axios.defaults.headers.common.Authorization = `Bearer ${response.data.jwtToken}`

        if (!this.$store.state.isLoggedIn) {
          this.$store.state.isTrainee = true
          this.isLoading = false
          this.$router.push('/')
          return
        }

        this.$store.state.isTrainee = false
        this.isLoading = false
        this.$router.push('/management-details')
      } catch (error) {
        this.$showError(error.response.data)
        this.password = ''
        this.isLoading = false
      }

      // else {
      //   this.$store.state.isTrainee = false
      //   this.$store.state.token = response.data.jwtToken
      //   this.$store.dispatch('initializeAxios', response.data.jwtToken)
      //   axios.defaults.headers.common.Authorization = `Bearer ${response.data.jwtToken}`
      // }

      // if (this.$store.state.isLoggedIn === true) {
      //   this.$router.push('/management-details')
      // } else {
      //   this.$showError('Invalid Login Credentials')
      //   this.password = ''
      // }
      // this.isLoading = false
    }
  }
  // mounted: function () {
  //   this.$store.state.isLoggedIn = false
  // }
}
</script>

<style scoped>
.login-body {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  background: #ababab;
}

.box {
  width: 470px;
  height: 580px;
  border: 2px solid rgba(255, 255, 255, .2);
  box-shadow: 0 0 10px rgba(0, 0, 0, .2);
  /* color: #fff; */
  border-radius: 15px;
  padding: 30px 60px;
  background: white;
}

.box img {
  transform: scale(0.8);
}

.input-box {
  position: relative;
  width: 100%;
  height: 70px;
}

.input-box {
  margin: 40px 0;
}

.input-box input {
  width: 100%;
  height: 100%;
  background: transparent;
  border: none;
  outline: none;
  border: 2px solid #ababab;
  /* border: 2px solid rgba(255, 255, 255, .2); */
  border-radius: 5px;
  font-size: 19px;
  color: #787878;
  padding: 5px 0px;
  padding-left: 7px;
}

.input-box input::placeholder {
  color: #ababab;
}

.input-box i{
  position: absolute;
  margin-right: 5px;
  right: 15px;
  top: 48%;
  transform: translateY(-50%);
  font-size: 30px;
  color: #787878;
  display: inline-block;
  width: 30px;
  height: 30px;
  line-height: 30px;
}

.box .btn-submit {
  position: relative;
  width: 100%;
  height: 60px;
  background: #006884;
  border: none;
  outline: none;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, .1);
  cursor: pointer;
  font-size: 20px;
  color: #FFF;
  font-weight: 600;
  text-decoration: none;
  display: inline-block;
  text-align: center;
  padding: 12px 0;
  margin-top: 15px;
}

.loading .btn-text {
  opacity: 0;
  visibility: hidden;
}

.box .loading::after {
  content: '';
  position: absolute;
  width: 35px;
  height: 35px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  border: 7px solid transparent;
  border-top-color: #ffffff;
  border-left-color: #ffffff;
  border-radius: 50%;
  animation: loading 1s linear infinite;
}

@keyframes loading {
  from {
    transform: rotate(0turn);
  }

  to {
    transform: rotate(1turn);
  }
}
</style>
